(function(){
  var html = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = html.classList.contains('shopify-design-mode');
  var mobile = window.matchMedia('(max-width: 749px)').matches;
  function $$(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function inView(el){ var r = el.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; }

  // ---------- Tag below-the-fold blocks that don't have a reveal yet ----------
  // Content already on screen at load is left alone, so nothing flickers.
  if (!reduce && !editor) {
    $$('main .o-wrap').forEach(function(wrap){
      if (wrap.closest('[data-o-reveal],[data-o-pdp],.o-hero')) return;
      Array.prototype.forEach.call(wrap.children, function(child){
        if (/^(STYLE|SCRIPT|TEMPLATE)$/.test(child.tagName) || child.hidden) return;
        if (child.hasAttribute('data-o-reveal') || child.querySelector('[data-o-reveal]')) return;
        var targets = (child.matches('.o-grid,.o-promises,.o-notes__grid') ? Array.prototype.slice.call(child.children) : [child]);
        // 96° lines are left out here: they get their own "draw" animation below
        targets.forEach(function(t){ if (!t.matches('.o-tilt') && !inView(t)) t.setAttribute('data-o-reveal', ''); });
      });
    });
    // 96° lines outside a reveal block draw on their own
    $$('main .o-tilt, .o-manifesto__line, .o-split > .o-tile:last-child').forEach(function(el){
      if (el.closest('[data-o-reveal]') || el.closest('.o-hero')) return;
      if (el.matches('.o-tilt') && inView(el)) return;
      el.setAttribute('data-o-draw', '');
    });
  }

  // ---------- Reveal on scroll, with a short stagger ----------
  var els = $$('[data-o-reveal],[data-o-draw]');
  function show(el, delay){
    if (delay) el.style.setProperty('--o-delay', delay + 's');
    el.classList.add('is-in');
    if (delay) setTimeout(function(){ el.style.removeProperty('--o-delay'); }, delay * 1000 + 1400);
  }
  if ('IntersectionObserver' in window && !reduce && !editor) {
    var io = new IntersectionObserver(function(entries){
      var batch = entries.filter(function(e){ return e.isIntersecting; }).map(function(e){ return e.target; });
      // stagger in reading order; on phones, items side by side in a row come in together
      batch.sort(function(a, b){
        var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
        return (ra.top - rb.top) || (ra.left - rb.left);
      });
      var step = mobile ? 0.06 : 0.08, lastTop = null, i = -1;
      batch.forEach(function(el){
        io.unobserve(el);
        var top = Math.round(el.getBoundingClientRect().top);
        if (!mobile || lastTop === null || Math.abs(top - lastTop) > 4) i++;
        lastTop = top;
        show(el, Math.min(i, 5) * step);
      });
    }, { rootMargin: mobile ? '0px 0px 6% 0px' : '0px 0px -8% 0px', threshold: 0 });
    els.forEach(function(el){ io.observe(el); });
  } else {
    els.forEach(function(el){ el.classList.add('is-in'); });
  }

  // ---------- Hero headline: rises in line by line ----------
  var heroH = document.querySelector('.o-hero__content > h1');
  if (heroH && !reduce && !editor) {
    var original = heroH.textContent;
    var split = function(){
      if (heroH.classList.contains('is-split')) return;
      var words = original.trim().split(/\s+/);
      heroH.innerHTML = words.map(function(w){ var s = document.createElement('span'); s.textContent = w; return s.outerHTML; }).join(' ');
      var lines = [], top = null;
      Array.prototype.forEach.call(heroH.children, function(s, i){
        if (top === null || Math.abs(s.offsetTop - top) > 2) { lines.push([]); top = s.offsetTop; }
        lines[lines.length - 1].push(words[i]);
      });
      heroH.innerHTML = '';
      lines.forEach(function(l, i){
        var outer = document.createElement('span'); outer.className = 'o-line';
        var inner = document.createElement('span'); inner.className = 'o-line__in';
        inner.style.setProperty('--o-delay', (0.1 + i * (mobile ? 0.08 : 0.12)) + 's');
        inner.textContent = l.join(' ');
        outer.appendChild(inner); heroH.appendChild(outer);
        if (i < lines.length - 1) heroH.appendChild(document.createTextNode(' '));
      });
      heroH.setAttribute('aria-label', original.trim());
      heroH.classList.add('is-split');
      // put the plain text back once the animation is done, so it re-wraps normally on resize
      setTimeout(function(){ heroH.textContent = original; heroH.removeAttribute('aria-label'); }, 1600 + lines.length * 120);
    };
    // wait for the brand font so lines are measured at their real width
    var waited = false;
    var go = function(){ if (!waited) { waited = true; split(); } };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(go);
    setTimeout(go, 700);
  }

  // ---------- Header: shrink a little after scrolling (CSS limits it to desktop) ----------
  var headerSec = document.querySelector('.o-header-section');
  if (headerSec && !reduce) {
    var scrolled = false, ticking = false;
    var onScroll = function(){
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      if (!scrolled && y > 60) { scrolled = true; headerSec.classList.add('is-scrolled'); }
      else if (scrolled && y < 20) { scrolled = false; headerSec.classList.remove('is-scrolled'); }
    };
    window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
  }

  // ---------- Small feedback: heart pop, count bumps, cart items ----------
  function replay(el, cls){ el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); setTimeout(function(){ el.classList.remove(cls); }, 600); }
  if (!reduce) {
    document.addEventListener('click', function(e){
      var w = e.target.closest('[data-o-wish]');
      if (w) replay(w, 'o-pop');
    });
    if ('MutationObserver' in window) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var lastCount = bubble.textContent.replace(/\D/g, '');
        new MutationObserver(function(){
          var c = bubble.textContent.replace(/\D/g, '');
          if (c !== lastCount) { lastCount = c; replay(bubble, 'o-bump'); }
        }).observe(bubble, { childList: true, subtree: true, characterData: true });
      }
      $$('[data-o-wish-count]').forEach(function(c){
        new MutationObserver(function(){ if (!c.hidden) replay(c, 'o-bump'); }).observe(c, { childList: true, characterData: true, subtree: true });
      });
      var cd = document.querySelector('cart-drawer');
      if (cd) {
        var wasOpen = cd.classList.contains('active');
        new MutationObserver(function(){
          var open = cd.classList.contains('active');
          if (open && !wasOpen) {
            $$('.cart-item, .o-pair', cd).forEach(function(it, i){
              it.style.setProperty('--o-i', Math.min(i, 6));
              it.classList.add('o-anim');
              setTimeout(function(){ it.classList.remove('o-anim'); }, 1200);
            });
          }
          wasOpen = open;
        }).observe(cd, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  // ---------- Mobile menu drawer ----------
  var drawer = document.getElementById('ODrawer');
  var openBtn = document.querySelector('[data-o-drawer-open]');
  function openDrawer(){
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ drawer.classList.add('is-open'); }); });
    document.body.classList.add('o-lock');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    var first = drawer.querySelector('[data-o-drawer-close]'); if (first) first.focus();
  }
  function closeDrawer(){
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('o-lock');
    if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
    setTimeout(function(){ drawer.hidden = true; }, 300);
  }
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  $$('[data-o-drawer-close]').forEach(function(b){ b.addEventListener('click', closeDrawer); });
  document.addEventListener('keyup', function(e){ if (e.key === 'Escape') closeDrawer(); });

  // ---------- Footer columns: open on desktop, accordions on mobile ----------
  var mq = window.matchMedia('(min-width: 990px)');
  function syncFooter(){
    $$('.o-fcol').forEach(function(d){ d.open = mq.matches; });
  }
  syncFooter();
  if (mq.addEventListener) mq.addEventListener('change', syncFooter); else mq.addListener(syncFooter);
})();
